import React from 'react';
import cn from 'classnames';
import {t} from '@lingui/core/macro';

import Copying from 'shared/ui/icons/Copying';
import {useCopyToClipboard} from 'shared/lib/hooks/useCopyToClipboard';

import styles from './CopyButton.module.scss';

interface ICopyButtonProps {
    value: string,
    disabled?: boolean,
    className?: string,
    tooltipClassName?: string,
    buttonClassName?: string,
    title?: string,
    ariaLabel?: string,
    stopPropagation?: boolean,
}

const CopyButton: React.FC<ICopyButtonProps> = ({
    value,
    disabled,
    className,
    tooltipClassName,
    buttonClassName,
    title,
    ariaLabel,
    stopPropagation,
}) => {
    const {copy, isCopied} = useCopyToClipboard();

    const onClick = (event: React.MouseEvent) => {
        if (stopPropagation) {
            event.stopPropagation();
        }

        copy(value);
    };

    return (
        <div className={cn(styles.container, className)}>
            {
                isCopied &&
                <div className={tooltipClassName ?? styles.tooltip} aria-live="polite">
                    {t`Скопировано!`}
                </div>
            }
            <button
                className={buttonClassName ?? styles.button}
                onClick={onClick}
                disabled={disabled}
                title={title}
                aria-label={ariaLabel ?? t`Скопировать`}
                type="button"
            >
                <Copying/>
            </button>
        </div>
    );
};

export default CopyButton;
